<div class="cart-footer">
    <div class="cart-footer__inner">

        <shared-cart-clear-btn [icon]="icon" [iconHover]="iconHover" (onClick)="handleClearCartClick($event)">{{label}}
        </shared-cart-clear-btn>

    </div>
</div>
